import axios from '../../config/axiosConfig';

export default {
  get: () => axios.get('/receivable/get_by_month'),
};
